import { JsonApiModelConfig } from '@elearnio/angular2-jsonapi';

import { EmailTemplate } from './email-template.model';

@JsonApiModelConfig({
  type: 'company_templates',
})
export class CompanyEmailTemplate extends EmailTemplate {}
